module.exports = __webpack_public_path__ + "static/media/flag-sw.e367e8f2.webp";